import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {MAT_DIALOG_DATA, MatTabChangeEvent} from '@angular/material';
import {AppComponent} from '../app.component';
import {LeftpanelComponent} from "../leftpanel/leftpanel.component";
import {EntityVersionChangeConfirmationComponent} from '../edit-entity/edit-entity.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-documentor',
  templateUrl: './documentor.component.html',
  styleUrls: ['./documentor.component.scss']
})
export class DocumentorComponent implements OnInit {

  @Input() schema: any;
  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');
  dataModel: any;
  index = false;
  dataModel1: any;
  apiByDefinition: any;
  subSection: any;
  subSectionSchema: any;
  section1 = {
    sections: [
      {
        title: '',
        description: '',
        sub_sections: [],
      }
    ]
  };
  @Input() data = {
    title: '',
    version: '',
    description: '',
    category_name: '',
    category_group: '',
    effective_date: '',
    sections: this.section1.sections,
    partner: '',
    account: '',
    isPublished: true
  };

  orig_data: any;
  @Output() onUpdate = new EventEmitter<any>();

  isEdit = false;

  constructor(private confPost: ConfService, public dialog: MatDialog, private platform: LeftpanelComponent, private _service: ConnecttocrudService) { }
  ngOnInit() {
    this.orig_data = JSON.parse(JSON.stringify(this.data));
    if (this.data.hasOwnProperty('isEdit') && this.data['isEdit'] === true) {
      this.isEdit = true;
      this.section1.sections = this.data.sections;
    }
    this.confPost.getEntity('services', 'services', 'documentor', 'v1').subscribe(result =>{
      this.apiByDefinition = result;
      this.getDataModelSchema();
      this.getDataModel1();
      this.subSection = {
        'title' : '',
        'description': '',
        'sub_sections': [],
      };
      this.subSectionSchema = {
        'title' : 'String',
        'description': 'String',
        'sub_sections': 'Object',
      };
    });
    function bindEvent(element, eventName, eventHandler) {
      if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.attachEvent('on' + eventName, eventHandler);
      }
    }
    bindEvent(window, 'message', function (e) {
      this.results = e.data;
      localStorage.setItem('htmlContent', e.data);
      this.body = e.data;
    });
  }
  getDataModelSchema() {
    this.dataModel = {};
    const that = this;
    this.apiByDefinition.attributes.forEach((data) => {
      if ( data.array === true ) {
        if ( data.type === 'Object') {
          this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
        } else {
          if (data.type.includes('_')) {
            this.dataModel[data.attributeName] = ['' + ' (id)'];
          } else {
            this.dataModel[data.attributeName] = '';
          }
        }
      } else if (data.type === 'Object') {
        this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
        this.dataModel[data.attributeName] = this.dataModel[data.attributeName][0];

      } else if (data.type !== 'Array' && data.type !== 'Object' && data.type !== 'Array Of Strings' && data.type !== 'Array Of Numbers' && data.type !== 'Integer' && data.type !== 'Boolean') {
        this.dataModel[data.attributeName] = '';
      } else if (data.type === 'Integer') {
        this.dataModel[data.attributeName] = '';
      } else if (data.type === 'Boolean') {
        this.dataModel[data.attributeName] = '';
      }
    });
    return this.dataModel;
  }
  changeData() {
    const str = 'Please make sure you save the description on the editor using the save button on the top';
    alert(str);
    if (localStorage.getItem('htmlContent').length > 0) {
      this.data.description = localStorage.getItem('htmlContent');
        const body = JSON.parse(this.data.description);
        this.data.description = body['html'];
    }
  }
  getSub(data) {
    const subType = [];
    const obj = {};
    const that = this;
    if (data.length > 0) {
      data.forEach((result) => {
        if ( result.array === true ) {
          if ( result.type === 'Object') {
            obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
          } else {
            if (result.type.includes('_')) {
              obj[result.attributeName] = ['' + ' (id)'];
            } else {
              obj[result.attributeName] = [''];
            }                    }
        } else if (result.type === 'Object') {
          obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
          obj[result.attributeName] = obj[result.attributeName][0];

        } else if (result.type !== 'Array' && result.type !== 'Object' && result.type !== 'Array Of Strings' && result.type !== 'Array Of Numbers' && result.type !== 'Integer' && result.type !== 'Boolean') {
          obj[result.attributeName] = '';
          // } else if (result.type === 'Array Of Strings' || result.type === 'Array Of Numbers') {
          //     obj[result.attributeName] = [];
        } else if (result.type === 'Integer') {
          obj[result.attributeName] = '';
        } else if (result.type === 'Boolean') {
          obj[result.attributeName] = '';
        }
      });
      subType.push(obj);
    }
    return subType;
  }
  saveDescription(title, value) {
    this.data[title] = value;
  }

  async update() {
    const payload = {
      effective_date: this.data.effective_date,
      sections: this.section1.sections,
      category_name: this.data.category_name,
      category_group: this.data.category_group,
      is_active: true,
      description: this.data.description,
      title: this.data.title,
      version: this.data.version,
      isPublished: this.data.isPublished
    };

    if (this.data.title && this.data.title !== '' && this.data.version && this.data.version !== '' && this.data.category_name && this.data.category_name !== '') {
      const change = [];
      if (this.data.title !== this.orig_data.title) {
        change.push('Title');
      }
      if (this.data.version !== this.orig_data.version) {
        change.push('Version');
      }
      let result = 'unchanged';
      if (change.length > 0) {
        const dialogRef = this.dialog.open(PageVersionChangeConfirmationComponent, {
          width: '60%',
          data: {
            title: payload.title,
            version: payload.version,
            message: change.join(', ').replace(/,([^,]*)$/, ' and$1') + ' has been changed. Do you want to create a new page or update the current page with the specified ' + change.join(', ').replace(/,([^,]*)$/, ' and$1') + '?'
          }
        });
        result = await dialogRef.afterClosed().toPromise();
      }

      if (result) {
        if (result === 'unchanged' || result === 'update') {
          if (result === 'update') {
            await this._service.getItemswithParameter('v1', 'services', 'services', 'documentor', 'title=' + this.data.title + '&version=' + this.data.version +  '&partner=' + this.partner + '&account=' + this.account).subscribe(resp => {
              let response: any;
              response = resp;
              if (response) {
                if (response.length > 0) {
                  this.platform.openSnackBar('A page with the given page title and version already exists.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                } else {
                  this.updateDocs(this.data['id'], payload);
                }
              } else {
                this.updateDocs(this.data['id'], payload);
              }
            }, error => {
              this.platform.openSnackBar('Error while updating the page. Please try again later.', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            });
          } else {
            this.updateDocs(this.data['id'], payload);
          }
        } else if (result === 'create') {
          this.Save();
        }
      }
    } else {
      this.platform.openSnackBar('Please fill all the required attributes.', 'Error', {
        duration: 7000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  updateDocs(id, payload) {
    this.confPost.patchEntityData('services', 'services', 'v1', 'documentor', id, payload).subscribe(response => {
      this.platform.openSnackBar('Page updated successfully.', 'Success', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      this.onUpdate.emit({status: 'success', data: payload});
    }, error => {
      this.platform.handleErrorGracefully(error, 'Error while updating the page. Please try again later.');
      this.onUpdate.emit({status: 'failed'});
    });
  }

  Save() {

    this._service.getItemswithParameter('v1', 'services', 'services', 'documentor', 'title=' + this.data.title + '&version=' + this.data.version +  '&partner=' + this.partner + '&account=' + this.account).subscribe(resp => {
      let response: any;
      response = resp;
      if (response) {
        if (response.length === 0) {
          const payload = {
            partner: this.partner,
            account: this.account,
            effective_date: this.data.effective_date,
            sections: this.section1.sections,
            category_name: this.data.category_name,
            category_group: this.data.category_group,
            is_active: true,
            description: this.data.description,
            title: this.data.title,
            version: this.data.version,
            isPublished: false
          };

          if (this.data.title && this.data.title !== '' && this.data.version && this.data.version !== '' && this.data.category_name && this.data.category_name !== '') {
            this.confPost.addItemServices('v1', 'documentor', payload).subscribe(success => {
              this.platform.openSnackBar('Page published successfully', 'Success', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              this.onUpdate.emit({status: 'success', data: payload});
            }, error => {
              this.platform.handleErrorGracefully(error, 'Error while publishing the page');
              this.onUpdate.emit({status: 'failed'});
            });
          } else {
            this.platform.openSnackBar('Please fill all the required attributes.', 'Error', {
              duration: 7000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          }
        } else {
          this.platform.openSnackBar('A page with the given page title and version already exists.', 'Error', {
            duration: 7000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      } else {
        this.platform.openSnackBar('Error while publishing the page', 'Error', {
          duration: 7000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.onUpdate.emit({status: 'failed'});
      }
    }, error => {
      this.platform.handleErrorGracefully(error, 'Error while publishing the page');
      this.onUpdate.emit({status: 'failed'});
    });
  }

  getDataModel1() {
    this.dataModel1 = {};
    const that = this;
    this.apiByDefinition.attributes.forEach((data) => {
      if ( data.array === true ) {
        if ( data.type === 'Object') {
          this.dataModel1[data.attributeName] = (that.getSub1(data.subType).length > 0 ? that.getSub1(data.subType) : []);
        } else {
          if (data.type.includes('_')) {
            this.dataModel1[data.attributeName] = [data.type + ' (id)'];
          } else {
            this.dataModel1[data.attributeName] = [data.type];
          }
        }
      } else if (data.type === 'Object') {
        this.dataModel1[data.attributeName] = (that.getSub1(data.subType).length > 0 ? that.getSub1(data.subType) : []);
        this.dataModel1[data.attributeName] = this.dataModel1[data.attributeName][0];

      } else if (data.type !== 'Array' && data.type !== 'Object' && data.type !== 'Array Of Strings' && data.type !== 'Array Of Numbers' && data.type !== 'Integer' && data.type !== 'Boolean') {
        this.dataModel1[data.attributeName] = data.type;
      } else if (data.type === 'Integer') {
        this.dataModel1[data.attributeName] = 'Integer';
      } else if (data.type === 'Boolean') {
        this.dataModel1[data.attributeName] = 'Boolean';
      } else if (data.type.includes('_')) {
        this.dataModel1[data.attributeName] = data.type + ' (id)';
      }
    });
    return this.dataModel1;
  }
  getSub1(data) {
    const subType1 = [];
    const obj1 = {};
    const that = this;
    if (data.length > 0) {
      data.forEach((result) => {
        if ( result.array === true ) {
          if ( result.type === 'Object') {
            obj1[result.attributeName] = (that.getSub1(result.subType).length > 0 ? that.getSub1(result.subType) : []);
          } else {
            if (result.type.includes('_')) {
              obj1[result.attributeName] = [result.type + ' (id)'];
            } else {
              obj1[result.attributeName] = [result.type];
            }                    }
        } else if (result.type === 'Object') {
          obj1[result.attributeName] = (that.getSub1(result.subType).length > 0 ? that.getSub1(result.subType) : []);
          obj1[result.attributeName] = obj1[result.attributeName][0];

        } else if (result.type !== 'Array' && result.type !== 'Object' && result.type !== 'Array Of Strings' && result.type !== 'Array Of Numbers' && result.type !== 'Integer' && result.type !== 'Boolean') {
          obj1[result.attributeName] = result.type;
          // } else if (result.type === 'Array Of Strings' || result.type === 'Array Of Numbers') {
          //     obj[result.attributeName] = [];
        } else if (result.type === 'Integer') {
          obj1[result.attributeName] = 0;
        } else if (result.type === 'Boolean') {
          obj1[result.attributeName] = false;
        }
      });
      subType1.push(obj1);
    }
    return subType1;
  }

  tabChanged(value) {
    if (value.index !== 0) {
      this.index = true;
    } else {
      this.index = false;
    }
  }
}

@Component({
  selector: 'page-version-change-confirmation',
  templateUrl: 'page-version-change-confirmation.component.html',
  styleUrls: ['page-version-change-confirmation.component.css']
})
export class PageVersionChangeConfirmationComponent {
  copyData = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  }

}
